// import { Button } from "@mantine/core";
// import ImageMessage from "components/ui/Layout/ImageMessage";
import { useEffect } from "react";

const RedirectHome: React.FC = () => {
  useEffect(() => {
    window.location.href = window.env.REACT_APP_URL_MY_SITE;
  }, []);

  return null;

  // return (
  //   <ImageMessage
  //     title="You have now been successfully registered"
  //     description={
  //       <Button
  //         component="a"
  //         href={window.env.REACT_APP_URL_MY_SITE}
  //         className="w-auto"
  //         size="lg"
  //         my="lg"
  //         color="red"
  //       >
  //         Take me to the DNA Portal
  //       </Button>
  //     }
  //   />
  // );
};

export default RedirectHome;